<template>
  <div class="commonPagination">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :layout="layout"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'commonPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: 'prev, pager, next, jumper'
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('update:currentPage', val)
      this.$emit('current-change', val)
    }
  }
}
</script>

<style lang="less" scoped>
.commonPagination{
  padding: 28px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/.el-pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
  }

  /deep/.el-pager{
    display: flex;
    align-items: center;
  }

  /deep/.el-pager li,
  /deep/.btn-prev,
  /deep/.btn-next{
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 3px;
    color: var(--text-secondary, #5A5F6B);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  /deep/.btn-prev,
  /deep/.btn-next{
    border-radius: 2px;
  }

  /deep/.el-pager li:hover{
    color: var(--primary, #FF5A1F);
  }

  /deep/.el-pager li.active{
    color: #FFFFFF;
    background: var(--primary, #FF5A1F);
    border-radius: 3px;
  }

  /deep/.el-pagination__jump{
    height: 32px;
    line-height: 32px;
    margin-left: 20px;
    display: inline-flex;
    align-items: center;
    color: var(--text-secondary, #5A5F6B);
  }

  /deep/.el-pagination__editor{
    height: 32px;
    line-height: 32px;
    display: inline-flex;
    align-items: center;
  }

  /deep/.el-input__inner{
    height: 32px;
    line-height: 32px;
    border-color: var(--border-soft, #E8E4DE);
    border-radius: 3px;
    color: var(--text-main, #111827);
    vertical-align: middle;
  }

  /deep/.el-input__inner:focus{
    border-color: var(--primary, #FF5A1F);
    box-shadow: none;
  }
}
</style>
